import ButtonTooltip from "components/Common/ButtonTooltip"
import ImageZipDownloader from "pages/StockPages/StockView/ImageZipDownloader"

const StockActionCell = ({
  stock,
  navigate,
  handleStockClick,
  onClickDelete,
  onClickDownload,
}) => {
  const stockId = stock?.stock_id
  return (
    <ul
      className="list-unstyled hstack gap-1 mb-0 flex-wrap"
      style={{
        minWidth: "4rem",
        maxWidth: "4rem",
        whiteSpace: "normal",
        overflowWrap: "break-word",
      }}
    >
      <li>
        <ButtonTooltip
          type="view"
          onClick={() => navigate(`/stock-list/${stockId}/view`)}
          btnId={`view-${stockId}`}
        />
      </li>

      <li>
        <ButtonTooltip
          type="edit"
          onClick={() => handleStockClick(stock)}
          btnId={`edit-${stockId}`}
        />
      </li>

      <li>
        <ButtonTooltip
          type="delete"
          onClick={() => onClickDelete(stock)}
          btnId={`delete-${stock.id}`}
        />
      </li>

      <li>
        <ButtonTooltip
          type="download"
          onClick={() => onClickDownload(stockId)}
          btnId={`download-${stockId}`}
        />
      </li>

      <li>
        <ImageZipDownloader
          btnText={""}
          loadingText={"..."}
          vehicleId={stockId}
        />
      </li>
    </ul>
  )
}

export default StockActionCell
